import { Injectable, OnInit, Inject } from '@angular/core';
import { ManagerService } from 'src/app/_core/services/manager.service';
import { catchError, EMPTY, map } from 'rxjs';
import { WindowsWrapper } from '../../app.config';
const { createLocalVideoTrack, createLocalAudioTrack, connect } = require('twilio-video');
 
let self;
@Injectable({
    providedIn: 'root'
})
export class AgentLiveMoniterService implements OnInit {
    authToken: any;
    debugMode: any = true;
    managerRoom: string;
    activeRoom: any;
    public WrapperOnvida: any;
    /*config = Inject(ConfigService).getConfig();*/
    constructor(private managerAPI: ManagerService, @Inject(WindowsWrapper) private OnvidaWrapper: any,) { }
    ngOnInit(): void {
        self = this;
        console.log(this.OnvidaWrapper);
    }
    initializePreview(data: any) {
        this.debugMode = data.debug
        this.debug(data);
        self = this;
        if (data.command == 'connect') {
            this.managerRoom = data.roomID;
            this.getToken();
        } else {
            this.leaveTwilioRoom();
        }
    }
    leaveTwilioRoom = function () {
        if (this.activeRoom?.state == 'connected')
            this.activeRoom.disconnect();
    }

    getToken() {
        this.managerAPI.GetVideoToken(this.managerRoom, null)
            .pipe(map((data: any) => {
                this.authToken = data.Response.Data;
                // this.debug(this.authToken, data.Response.Data);
                this.joinTwilioRoom(this.managerRoom);
            }),
                catchError(error => {
                    this.debug(error);
                    return EMPTY;
                })
            ).subscribe();
    }
    joinTwilioRoom = async function (roomID) {
        var localTracks = new Array();
        createLocalAudioTrack().then(audioTrack => {
            if (typeof audioTrack != 'undefined')
                localTracks.push(audioTrack);

            this.debug('LiveView - Warning: Audio Track Undefined', audioTrack);

            return createLocalVideoTrack({
                mandatory: {
                    maxWidth: 3840,
                    maxHeight: 1080,
                    minFrameRate: 10,
                    maxFrameRate: 30,
                    chromeMediaSource: 'desktop'
                }
            }).then(localVideoTrack => {
                self.debug('Video', localVideoTrack);
                return localVideoTrack;
            });

        }).then(desktopTrack => {
            localTracks.push(desktopTrack);
            self.debug('desktopTrack', localTracks);
            return connect(self.authToken, { name: roomID, tracks: localTracks });
        }).then(room => {
            self.debug(`Connected to Room: ${room.name}`);
            this.activeRoom = room;

            self.debug('LiveView - Connected to Room: ' + room.name);

            this.handleEvents(room);
        });

    }
    handleEvents(room: any) {

        //room.localParticipant.videoTracks.forEach(publication => {
        //    publication.track.disable();
        //});

        room.on('participantConnected', participant => {
            self.debug(`Participant connected: ${participant.identity}`);
        });

        room.localParticipant.audioTracks.forEach(publication => {
            publication.track.disable();
        });
        function handleTrackEnabled(track) {
            self.debug(track);
            track.on('enabled', () => {
                /* Hide the avatar image and show the associated <video> element. */
            });
        }

        room.participants.forEach(participant => {
            participant.tracks.forEach(publication => {
                if (publication.isSubscribed) {
                    handleTrackEnabled(publication.track);
                }
                publication.on('subscribed', handleTrackEnabled);
            });
        });
        room.on('disconnected', function (room, error) {
            if (error) {
                self.debug('Unexpectedly disconnected:', error);
            }
            room.localParticipant.tracks.forEach(publication => {
                const attachedElements = publication.track.detach();
                attachedElements.forEach(element => element.remove());
            });
            self.debug(`Room disconnected done`);
        });
        room.on('participantReconnecting', participant => {
            self.debug(participant.identity + ' is reconnecting to the Room');
        });
        room.on('participantDisconnected', function (participant) {
            self.debug(participant.identity + ' left the Room');
            participant.tracks.forEach(function (track) {
                track.detach().forEach(function (mediaElement) {
                    mediaElement.remove();
                });
            });
        });
        room.on('reconnected', () => {
            self.debug('Reconnected!');
        });
    }
    debug(msg: string, obj?: any) {
        if (this.debugMode) {
            console.log(msg);
        }
    }
    isWrapper() {
        return this.OnvidaWrapper.IsWrapper;
    }
    
}
